import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Assign } from "../types/types";
import { RootState } from "./index.store";

/* Actions */
const actionCreator = actionCreatorFactory("assigns");
export const assignsActions = {
  /* SYSTEM ACTIONS */
  SYSTEM_FETCH_ALL_ASSIGNS: actionCreator("SYSTEM_FETCH_ALL_ASSIGNS"),
  /* REDUCER ACTIONS */
  REDUCER_SET_ASSIGNS: actionCreator<Assign[]>("REDUCER_SET_ASSIGNS")
};

/* Selectors */
/**
 * 全てのアサインを返す
 * @param state
 */
export const assignsSelector = (state: RootState) => state.domain.assigns;

/**
 * アサインリデューサー
 */
export const assignsReducer = reducerWithInitialState<Assign[]>([]).case(
  assignsActions.REDUCER_SET_ASSIGNS,
  (state, payload) => payload
);
